var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"arrow-button text-small",on:{"click":function($event){return _vm.goBack()}}},[_vm._v(_vm._s(_vm.title))])}
var staticRenderFns = []

export { render, staticRenderFns }